export default "__VITE_ASSET__BSBhdVG5__"